<template>
  <div class="col-md-12">
    <!-- Disclaimer Payment -->
    <ConsentDisclaimer
      :submit="submit"
      :inline_disclaimer_and_consent="false"
      :allow_separate_signature="false"
      :allow_consent="false"
      :allow_disclaimer="allowDisclaimer"
      :allow_text_name_disclaimer="false"
      :disclaimer_name_text="disclaimerNameText"
      :allow_signature_disclaimer="allowSignatureDisclaimer"
      :disclaimer_en="disclaimer"
      :disclaimer_es="disclaimer"
      :disclaimer_zh="disclaimer"
      :partOfSection ="true"
      @validateSignature="validateDisclaimerSection"
      ref="ConsentDisclaimer" />
    <!-- Questions Section -->
    <QuestionsSection ref="questions" :section="bill.type"></QuestionsSection>

    <!-- Insurance -->
    <Insurance ref="insurance" v-if="bill.type === 'insurance'"  @updateModel="updateModel" @validateBill="validateBill" />

    <!-- Commercial Uninsured -->
    <Uninsured ref="uninsured" v-if="bill.type === 'uninsured'" @updateModel="updateModel" @validateBill="validateBill" />

    <!-- Note -->
    <Note @updateModel="updateModel" v-if="bill.type !== 'insurance'" />

    <!-- Self Pay Cash -->
    <Cash ref="cash" v-if="bill.type === 'cash'" @updateModel="updateModel" @validateBill="validateBill" />

    <!-- Client Bill -->
    <ClientBill ref="client_bill" v-if="bill.type === 'client_bill'" @updateModel="updateModel" @validateBill="validateBill" />
  </div>
</template>

<script>
import {Col, Row, Input, Button, RadioGroup, Radio, RadioButton} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {AccessionUtils} from '../../../../../../utils/AccessionDetailsProcessing'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {LayoutCalculationUtils} from '../../../../../../utils/LayoutCalculation'
import Insurance from './Insurance'
import Cash from './Cash'
import ClientBill from './ClientBill'
import Uninsured from './Uninsured'
import Note from './Note'
import QuestionsSection from '../../Sections/QuestionsSection'
import ConsentDisclaimer from '../../Sections/ConsentDisclaimer'
import {QuestionUtils} from '../../../../../../utils/Questions'

export default {
  name: 'Bill',
  props: ['bill'],
  components: {
    ConsentDisclaimer,
    QuestionsSection,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [RadioButton.name]: RadioButton,
    [Input.name]: Input,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    Insurance,
    Cash,
    ClientBill,
    Uninsured,
    Note
  },
  mixins: [
    TranslationsUtils,
    AccessionUtils,
    SettingsUtils,
    LayoutCalculationUtils,
    QuestionUtils
  ],
  data () {
    return {
      allBills: [],
      submit: false,
      disclaimer: '',
      allowDisclaimer: false,
      disclaimerNameText: 'If you can not sign, please type your name here',
      allowSignatureDisclaimer: false,
      model: {
        social_security_number: '',
        driver_license_number: '',
        primary_insurance: '',
        primary_insurance_name_input: '',
        policy_number: '',
        group_number: '',
        relationship: '',
        insurance_pay: '',
        insured_first_name: '',
        insured_middle_name: '',
        insured_last_name: '',
        insured_date_of_birth: '',
        insured_date_of_birth_pretty: '',
        insured_address_components: {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        },
        insured_gender: '',
        insurance_card_images: [],
        insurance_card_names: [],
        error_uninsured: '',
        note: ''
      }
    }
  },
  methods: {
    async validate () {
      if (this.bill.type) {
        await this.$refs[this.bill.type].validate()
      }
      if (this.allowDisclaimer) {
        this.submit = true
        let disclaimerValidation = await this.$refs.ConsentDisclaimer.validate()
        if (disclaimerValidation === false) {
          return this.model
        }
      }
      let validator = true
      let questionValidation = this.validateQuestions(this.$store.state.questions, validator, this.bill.type)
      if (questionValidation === false) {
        await this.$refs.questions.focusQuestions()
      }
      if (!questionValidation) {
        this.validateQuestionSection(false)
        return this.model
      }
      this.submit = false
      return this.model
    },
    updateModel (modelObject) {
      Object.assign(this.model, modelObject)
    },
    validateBill (booleanValue) {
      this.$emit('validateBill', booleanValue)
    },
    validateDisclaimerSection (booleanValue) {
      this.$emit('validateSignature', booleanValue)
    },
    validateQuestionSection (booleanValue) {
      this.$emit('validateQuestion', booleanValue)
    },
    checkDisclaimer () {
      if (this.disclaimer !== null && this.disclaimer !== '' && this.disclaimer !== undefined || this.allowSignatureDisclaimer) {
        this.allowDisclaimer = true
      } else {
        this.allowDisclaimer = false
        this.validateDisclaimerSection(true)
      }
      if (this.allowSignatureDisclaimer) {
        this.validateDisclaimerSection(false)
      }
      setTimeout(() => {
        if (this.allowDisclaimer) {
          if (this.allowSignatureDisclaimer) {
            this.$refs.ConsentDisclaimer.clearDisclaimerSignature()
            this.validateDisclaimerSection(false)
          } else {
            this.validateDisclaimerSection(true)
          }
        } else {
          this.validateDisclaimerSection(true)
        }
      }, 100)
    }
  },
  async beforeMount () {
  },
  mounted () {
  },
  computed: {
  },
  watch: {
    'bill': {
      handler: function (val) {
        if (this.bill.type !== 'cash') {
          this.$store.state.cashPayment = ''
        }
        this.$store.state.insuranceType = this.bill.type
        this.disclaimer = this.bill.disclaimer
        this.allowSignatureDisclaimer = this.bill.signature
        this.checkDisclaimer()
        let validator = true
        let questionValidation = this.validateQuestions(this.$store.state.questions, validator, this.bill.type)
        this.validateQuestionSection(questionValidation !== false)
      },
      immediate: true,
      deep: true
    },
    '$store.state.questions': {
      handler (before, after) {
        if (this.$store.state.configs['SINGLE_PAGE_ORDERS'] === true) {
          this.$store.state.icdCodes = []
          let validator = true
          let questionValidation = this.validateQuestions(this.$store.state.questions, validator)
          if (questionValidation === false) {
            this.$store.state.icdCodes = []
          }
        }
        let validator = true
        let questionValidation = this.validateQuestions(this.$store.state.questions, validator, this.bill.type)
        this.validateQuestionSection(questionValidation !== false)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/Bill.vue